<template>
  <div>
    <!-- <PageHeader :layout="'default'" />

    <SlideMenuDownTransition>
      <MegaMenu v-if="menuState" />
    </SlideMenuDownTransition> -->

    <div class="error-logo spacing-alternative" @click="handleError">
      <MediaElement 
        :src="'/ws-logo-basic.svg'" 
        :alt="'W-S Logo'" 
        :classes="'logo ux-element'"
      ></MediaElement>
    </div>

    <div class="error-content bg-dark-blue">
      <div v-if="error?.statusCode === 404" v-html="globals.pagecontent.page_not_found_text"></div>
      <PacManError v-if="error?.statusCode === 404" />
  
      <button @click="handleError" class="button cta--default flex-row inline-flex">
        <span class="label">Home</span>
        <span class="basis-auto">
          <div class="circle circle-default"></div>
        </span>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
    import type { NuxtError } from '#app'
    import { useRequestStore } from '@/stores/requests'
    import { useGlobalsStore } from '@/stores/globals'

    const props = defineProps({
        error: Object as () => NuxtError,
    })

    const requestStore = useRequestStore()
    const { globals } = storeToRefs(requestStore)

    const globalsStore = useGlobalsStore()
    const { menuState } = storeToRefs(globalsStore)

    const localePath = useLocalePath()

    const handleError = () => {
      clearError()
      window.location.replace(localePath('/'))
    }
</script>

<style scoped>
  .error-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: var(--color-dark-blue);
    color: var(--color-white);
    min-height: 100vh;
    padding: 0 30px;
  }

  .error-content.bg-dark-blue button {
    margin-top: 40px;
    
    .label {
      color: #fff;
      transition: var(--default-transition);
  
      &:hover {
        color: var(--color-dark-blue);
      }
    }
  }

  .error-logo {
    position: fixed;
    top: 0px;
    right: 0px;
    cursor: pointer;
  }
</style>